import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useNowGeneralContext } from '../../../../../now'

export const ProductBuyBoxNowInfoSeeDetailsButton: FC = () => {
  const { productPageNowDialogControls } = useNowGeneralContext()

  return (
    <button
      className="underline"
      data-qa-id="buybox-check-now"
      onClick={productPageNowDialogControls.handleOpen}
      type="button"
    >
      <FormattedMessage id="general.label.seeDetails" />
    </button>
  )
}
